import Pendulum from "@clinic/emerson/assets/images/homepage/24-06_EEHero-Pendulum_DkHero.png";
import Protocol from "@clinic/emerson/assets/images/homepage/24-06_EEHero-Protocol_DkHero.png";
import VitalNutrients from "@clinic/emerson/assets/images/homepage/24-06_EEHero-Vital-Nutrients_DkHero.png";
import type { WordpressHomeSlidesType } from "@emerson/data/queries/WordpressHomeSlidesQuery/WordpressHomeSlidesQuery.query";

const MockHomeCarouselData: WordpressHomeSlidesType[] = [
  {
    title: "Help your patients support satiety, naturally*",
    homeSlideText:
      "GLP-1 Probiotic Pro naturally supports GLP-1 production^, a satiety hormone that helps maintain a healthy weight.*",
    homeSlideDisplayOrder: 1,
    homeSlideImage: Pendulum,
    homeSlideActionUrl:
      "https://go.emersonecologics.com/pendulum-pro/#utm_source=hero&utm_medium=ee.com&utm_campaign=PEND&utm_term=Buy_Now",
    homeSlideActionText: "Buy now",
  },
  {
    title: "New! Sleep + Recover",
    homeSlideText:
      "A unique formula of seven clinically studied ingredients designed to help you fall asleep faster, stay asleep longer, and wake up refreshed.*",
    homeSlideDisplayOrder: 2,
    homeSlideImage: VitalNutrients,
    homeSlideActionUrl:
      "/products/detail/brand/sleep-recover/U3ByZWU6OlByb2R1Y3QtMTAxMDg4/sleep-recover?utm_source=hero&utm_medium=ee.com&utm_campaign=VN&utm_term=Buy_Now",
    homeSlideActionText: "Learn more",
  },
  {
    title: "400mg Longvida® Optimized Curcumin for Cognitive Support*",
    homeSlideText:
      "Solid Lipid Curcumin Particle (SLCP™) technology used in Cogumin SLCP™ allows free curcuminoids to reach the brain & help support normal cognitive function.*",
    homeSlideDisplayOrder: 3,
    homeSlideImage: Protocol,
    homeSlideActionUrl:
      "/products/detail/brand/cogumin-slcp-50-vegcaps/U3ByZWU6OlByb2R1Y3QtNzY4Mjg=/cogumin-slcp-50-vegcaps?utm_source=hero&utm_medium=ee.com&utm_campaign=PROT&utm_term=Buy_Now",
    homeSlideActionText: "Buy now",
  },
];

export { MockHomeCarouselData };
